import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiChevronDown } from 'react-icons/fi';

const faqs = [
  {
    q: 'OSTONA nima?',
    a: "OSTONA — bu yangi kvartira qidirish, 3D ko'rish, onlayn shartnoma tuzish va ipoteka kalkulyatorini o'z ichiga olgan yagona mobil platforma. Qurilish kompaniyalari bilan bevosita bog'lanish imkoniyatini beradi.",
  },
  {
    q: "Ilova bepulmi?",
    a: "Ha, OSTONA ilovasi barcha foydalanuvchilar uchun mutlaqo bepul. Kvartira qidirish, 3D ko'rish va barcha asosiy imkoniyatlardan bepul foydalanasiz.",
  },
  {
    q: "Kvartira bron qilish qanday ishlaydi?",
    a: "Ilovada yoqqan kvartirani tanlab, 'Bron qilish' tugmasini bosasiz. Bron to'lovi qilingandan so'ng kvartira sizga 48 soat davomida band qilinadi.",
  },
  {
    q: "Online shartnoma qanchalik ishonchli?",
    a: "Barcha shartnomalar qonuniy kuchga ega va ERI (elektron raqamli imzo) bilan tasdiqlanadi. Hujjatlar xavfsiz serverda saqlanadi.",
  },
  {
    q: "Quruvchilar qanday tekshiriladi?",
    a: "Har bir qurilish kompaniyasi OSTONA jamoasi tomonidan sinchiklab tekshiriladi — litsenziya, qurilish tarixi, mijozlar fikri va moliyaviy barqarorlik baholanadi.",
  },
  {
    q: "Ipoteka olsa bo'ladimi?",
    a: "Ha! OSTONA 6 ta yetakchi bank bilan hamkorlik qiladi. Ilova ichida ipoteka arizangizni to'ldiring va eng qulay shartlarni tanlang.",
  },
  {
    q: "3D planirovka qanday ishlaydi?",
    a: "Har bir kvartira uchun 360° interaktiv 3D model mavjud. Barmoq harakati bilan xonalarni aylantiring va ichini batafsil ko'ring.",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const toggle = (i) => setActiveIndex(activeIndex === i ? null : i);

  return (
    <section className="faq-section section-container" id="faq" ref={ref}>
      <div className="faq-header">
        <span className="section-tag">FAQ</span>
        <h2 className="section-title">
          Ko'p beriladigan <span className="gold-text">savollar</span>
        </h2>
        <p className="section-desc">
          OSTONA haqida eng ko'p so'raladigan savollarga javoblar.
        </p>
      </div>

      <motion.div
        className="faq-list"
        initial={{ opacity: 0, y: 20 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        {faqs.map((faq, i) => (
          <div className={`faq-item${activeIndex === i ? ' active' : ''}`} key={i}>
            <div className="faq-question" onClick={() => toggle(i)}>
              <h3>{faq.q}</h3>
              <span className="faq-chevron"><FiChevronDown /></span>
            </div>
            <AnimatePresence>
              {activeIndex === i && (
                <motion.div
                  className="faq-answer"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: 'easeInOut' }}
                  style={{ overflow: 'hidden' }}
                >
                  {faq.a}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </motion.div>
    </section>
  );
};

export default FAQ;
